<div id="jupiter-block-container">
  <!-- Primera card -->
  <div class="card-container surface-50">
    <div class="card">
      <div class="item-left">
        <p class="display-01-black color-900 title">
          Potenciá tu crecimiento con Pro+
        </p>
        <p class="sub subheading-01-semi-bold color-800">
          Esta funcionalidad está disponible solo para QR Pro+. Actualizá tu
          plan y accedé a funcionalidades de otro nivel.
        </p>
        <qr-button
          [config]="buttonWithIcon40pxHierarchy1"
          (click)="onSendWhatsappBot()"
        ></qr-button>
      </div>
      <div class="item-right">
        <img
          class="image"
          id="rocket"
          src="./../../../assets/images/jupiter-block/rocket-image.png"
          alt=""
        />
      </div>
    </div>
  </div>
  <!-- Primera card -->
  <!-- Segunda card -->
  <div class="card-container grey-100">
    <div class="card">
      <div class="item-left">
        <img
          class="image"
          id="app"
          src="./../../../assets/images/jupiter-block/appmovil-image.png"
          alt=""
        />
      </div>
      <div class="item-right">
        <p class="display-01-black color-900 title">App. móvil</p>
        <p class="sub subheading-01-semi-bold color-800">
          Descargate la aplicación en tu celular y accede a todos los <br />
          datos estadísticos de tu negocio de manera rápida y <br />
          conveniente.
        </p>
      </div>
    </div>
  </div>
  <!-- Segunda card -->
  <!-- Tercera card -->
  <div class="card-container surface-50">
    <div class="card column">
      <div class="item-right item-column">
        <p class="display-01-black color-900 title">
          Planificación de gestión de agentes
        </p>
        <p class="sub subheading-01-semi-bold color-800">
          <ng-container *ngIf="NODE_ENV != NODE_PY; else textPY">
            Todos tus Agentes podrán ver su resumen consolidado, cargar
            objetivos y tener su <br />
            propio Dashboard donde verán su progreso anual. Incluye Ranking Red
            Agente.
          </ng-container>
          <ng-template #textPY>
            Planificación de gestión de agentes Podrás cargar objetivos a tus
            agentes, <br />
            realizarles seguimiento y visualizar el Ranking del agente en la
            Red!
          </ng-template>
        </p>
        <qr-button
          [config]="buttonWithIcon40pxHierarchy1"
          (click)="onSendWhatsappBot()"
        ></qr-button>
        <img
          class="image"
          id="planif"
          src="./../../../assets/images/jupiter-block/planif-agentes.png"
          alt=""
        />
      </div>
    </div>
  </div>
  <!-- Tercera card -->
  <!-- Cuarta card -->
  <div class="card-container grey-100">
    <!-- Argentina -->
    <div class="card" *ngIf="NODE_ENV == NODE_AR">
      <div class="item-left">
        <p class="display-01-black color-900 title">Facturación electrónica</p>
        <p class="sub subheading-01-semi-bold color-800">
          Factura masivamente a tus agentes de forma ágil y eficiente.
        </p>
      </div>
      <div class="item-right">
        <img
          class="image"
          id="billing"
          src="./../../../assets/images/jupiter-block/billing.png"
          alt=""
        />
      </div>
    </div>
    <!-- Uruguay -->
    <div class="card" *ngIf="NODE_ENV != NODE_AR">
      <div class="item-left">
        <p class="display-01-black color-900 title">Reservómetro histórico</p>
        <p class="sub subheading-01-semi-bold color-800">
          Gráfico con la evolución de tus reservas a cobrar.
        </p>
      </div>
      <div class="item-right">
        <img
          class="image"
          id="billing"
          src="./../../../assets/images/jupiter-block/reservometro.png"
          alt=""
        />
      </div>
    </div>
  </div>
  <!-- Cuarta card -->
  <!-- Quinta card -->
  <div class="card-container surface-50">
    <div class="card column">
      <div class="item-right item-column">
        <p class="display-01-black color-900 title">
          Descubrí más funcionalidades
        </p>
        <div id="swiper-container">
          <swiper
            class="swiper"
            *ngIf="this.swiperConfig"
            [config]="this.swiperConfig"
          >
            <div class="swipper-slide" *ngFor="let card of this.cardsArray">
              <div class="card-swipper">
                <div class="background-container">
                  <div class="icon-container">
                    <div class="icon" [id]="card.icon"></div>
                  </div>
                </div>
                <p class="heading-02-black title grey-900 title-card">
                  {{ card.title }}
                </p>
                <p class="subheading-01-semi-bold grey-800">{{ card.sub }}</p>
              </div>
            </div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
  <!-- Quinta card -->
  <!-- Sexta card -->
  <div class="card-container grey-100">
    <div class="card column" id="last-card">
      <div class="item-right item-column">
        <p class="display-01-black color-900 title">
          ¿Listo para llevar tu experiencia al <br />
          siguiente nivel?
        </p>
        <p class="sub subheading-01-semi-bold color-800 center">
          Realizá la actualización y aprovecha todas estas nuevas
          funcionalidades ¡Bienvenido a <br />
          la era de QR Pro+!
        </p>
        <qr-button
          [config]="buttonWithIcon40pxHierarchy1"
          (click)="onSendWhatsappBot()"
        ></qr-button>
      </div>
    </div>
  </div>
  <!-- Sexta card -->
</div>

<!-- Agregar o editar notificacion -->
<qr-dialog
  [config]="this.dialogSuccess"
  (dialogChange)="onDialogSuccess($event)"
></qr-dialog>
